import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import {
  AuthenticationService,
  LocalStorageService,
  SolPreferenceStore,
  SolSettingKey,
  SolTableLayout,
  TableTools,
} from '@sol/components';
import { AsmTableLayoutSettings } from '@asm/components-table/services/asm-table-layout-settings';

@Injectable({ providedIn: 'root' })
export class LicensingPreferencesService implements SolPreferenceStore, AsmTableLayoutSettings {
  private readonly storage = inject(LocalStorageService);
  private readonly authentication = inject(AuthenticationService);
  public load(name: string): Observable<unknown> {
    return of(this.storage.get(this.key(name)));
  }
  public save(name: string, value: unknown): Observable<void> {
    this.storage.set(this.key(name), value);
    return of(undefined);
  }
  public reset(name: string): Observable<void> {
    this.storage.remove(this.key(name));
    return of(undefined);
  }
  public prePaint(): Observable<Record<string, unknown>> {
    return of({ [SolSettingKey.theme.name]: this.storage.get(SolSettingKey.theme.name) ?? null });
  }
  public tableKey(tableId: string): SolSettingKey<SolTableLayout> {
    return SolSettingKey.of(`asm:table:${tableId}:columns`, TableTools.toStoredLayout);
  }
  public ownsTableLayout(tableId: string): boolean {
    return this.storage.get(this.key(`asm:table:${tableId}:columns`)) !== undefined;
  }
  private key(name: string): string {
    return name === SolSettingKey.theme.name ? name : `${this.authentication.state.email ?? 'anonymous'}.${name}`;
  }
}
